








































import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  name: 'lander004',
  components: {
    SignupWhiteGloveBox: () => import('@/components/SignupWhiteGloveBox.vue'),
  }
})
export default class Lander004 extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public image: string

  // public reactive member variables available to the html template
  public whiteGloveSignUpHeader: string = null
  public buttonCTA: string = null

  // public functions available to the html template
  public clickedSignUp() {
    this.$emit('clickedCTA')
  }

  // lifecycle hooks

  // private, non-reactive member variables

  // private functions not available directly to HTML template

  // this is necessary because path changes don't reload the component nor its subcomponents

}

